var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283715",
    "data-name": "Pfad 283715",
    d: "M35.938,24.743a3.942,3.942,0,0,0-3.777-3.014.69.69,0,0,1,0-.107,5.69,5.69,0,0,0-1.884-4.815,5.969,5.969,0,0,0-5.027-1.274,5.887,5.887,0,0,0-3.992,2.991l-.113-.033A5.4,5.4,0,0,0,15.62,20a6.433,6.433,0,0,0-1.448,6.5A5.767,5.767,0,0,0,20,30.575h1a.575.575,0,0,0,0-1.15H20a4.633,4.633,0,0,1-4.741-3.3,5.276,5.276,0,0,1,1.189-5.328A4.226,4.226,0,0,1,20.831,19.6a1.873,1.873,0,0,1,.24.08.842.842,0,0,0,1.124-.465A4.709,4.709,0,0,1,25.47,16.66a4.819,4.819,0,0,1,4.053,1.017,4.632,4.632,0,0,1,1.488,3.888,1.058,1.058,0,0,0,.914,1.248A2.984,2.984,0,0,1,34.818,25a3.546,3.546,0,0,1-2.405,4.3c-.081.021-.163.041-.242.054a4.3,4.3,0,0,1-.721.065l-1.412.006a.575.575,0,0,0,0,1.15h0l1.415-.006a5.634,5.634,0,0,0,.913-.082c.115-.021.231-.048.343-.078A4.692,4.692,0,0,0,35.938,24.743Z",
    transform: "translate(-13 -13)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283716",
    "data-name": "Pfad 283716",
    d: "M28.907,32.594a.575.575,0,0,0-.814,0l-2.018,2.017V25.5a.575.575,0,0,0-1.15,0v9.111l-2.018-2.017a.575.575,0,0,0-.814.812l3,3a.575.575,0,0,0,.814,0l3-3A.575.575,0,0,0,28.907,32.594Z",
    transform: "translate(-13 -13)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18788",
    "data-name": "Gruppe 18788",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24197",
    "data-name": "Rechteck 24197",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download_white.23ab139156cad595a048e35dc4aa7045.svg";
export { ForwardRef as ReactComponent };